/* @flow */
import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import './FooterContainer.css'
import logo from '../../images/Novo_Logo-solid-green.svg'
import footerCurve from '../../images/background_curve-out-up-dark.svg'

type Props = {
	changePage: Function,
}

class FooterContainer extends Component<Props> {
  render() {
    return (
			<footer>
				<img className="footer-curve" src={footerCurve} />
				<div className="footer-background">
					<div className="footer container">
						<div className="footer--logo">
							<a href="/">
								<img src={logo}/>
							</a>
						</div>
						<ul className="footer--nav--list">
	            <li className="footer--nav--list-title">Learn More</li>
							<li className="footer--nav--list-item"><a href="#use_cases">USE CASES</a></li>
							<li className="footer--nav--list-item"><a href="#about">ABOUT</a></li>
							<li className="footer--nav--list-item"><a href="#roadmap">ROADMAP</a></li>
							<li className="footer--nav--list-item"><a href="#team">TEAM</a></li>
						</ul>
	          <ul className="footer--nav--list">
	            <li className="footer--nav--list-title">Join The Community</li>
							<li className="footer--nav--list-item"><a href="https://www.twitter.com/rye_labs" target="_blank"><i className="icon-lg icon-fw icon icon-twitter" />TWITTER</a></li>
							{/*
							<li className="footer--nav--list-item"><a href="https://www.slack.com/" target="_blank"><i className="icon-lg icon-fw icon icon-slack-hash" />SLACK</a></li>
							<li className="footer--nav--list-item"><a href="https://www.telegram.com/" target="_blank"><i className="icon-lg icon-fw icon icon-telegram-plane" />TELEGRAM</a></li>
							*/}
							<li className="footer--nav--list-item"><a href="https://www.medium.com/NovoProtocol" target="_blank"><i className="icon-lg icon-fw icon icon-medium-m" />MEDIUM</a></li>
						{/*<li className="footer--nav--list-item"><a href="https://discord.gg/YsDM84n" target="_blank"><i className="icon-lg icon-fw icon icon-discord" />DISCORD</a></li>*/}
						</ul>
	          <ul className="footer--nav--list">
							{/*
	            <li className="footer--nav--list-title">Language</li>
							<li className="footer--nav--list-item"><a>ENGLISH <i className="icon icon-chevron-small-down"/></a></li>
							*/}
						</ul>
					</div>
				</div>
			</footer>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: (path) => push(path)
}, dispatch)

export default connect(null, mapDispatchToProps)(FooterContainer)



// WEBPACK FOOTER //
// ./src/App/FooterContainer/FooterContainer.js